export default {
  directives: {
    autofocus: {
      inserted: function (el) {
        if (el.tagName == 'INPUT') {
          el.focus()
        } else {
          const childInput = el.querySelector('input')
          if (childInput != null) {
            childInput.focus()
          } else {
            console.warn(`[VueAutofocus] Child <input> element not found for:`, el)
          }
        }
      },
    },
  },
}
